 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0271a4fe":"d51bd375","chunk-01cd1471":"19a10cbc","chunk-2595df72":"47f77579","chunk-4b7bd220":"7f759c64","chunk-7caefa32":"b167fd50","chunk-96a43c8c":"d474336c","chunk-047dd522":"fc825d60","chunk-04800f29":"d28a8078","chunk-0dd84c1c":"7427c2bf","chunk-16c503df":"b52f2009","chunk-1f099dec":"650e059b","chunk-20533f34":"63f0e995","chunk-2857cb7b":"7fa78dc3","chunk-2bfb1400":"0b907e00","chunk-2d5cec40":"2bff72d7","chunk-2fd67220":"f9ee33fc","chunk-3140e884":"b1da7ea6","chunk-3d2ddda4":"74b7aa0c","chunk-3fd29c42":"d5574ebb","chunk-4259022d":"ed2dda40","chunk-43b69a23":"b592b3d5","chunk-45e957a2":"e06aef22","chunk-4dd3fbf5":"05f48d62","chunk-4f919cd6":"93ab609e","chunk-5b93a306":"2645eaa6","chunk-5cbc4bea":"5f1fcef9","chunk-625c0003":"db004b3e","chunk-6809adbd":"05d4ddba","chunk-694f629f":"19f552d4","chunk-6e227986":"7c08222f","chunk-704dd3c0":"b8203fbf","chunk-72c176ea":"3ac37541","chunk-7e408375":"9c0cb702","chunk-7f9fa58a":"860aca98","chunk-8c26676c":"88790c8b","chunk-9cc31c2a":"fe03275a","chunk-aa8c7f08":"e0521cbb","chunk-da7642cc":"4ef4b2a0","chunk-de7a6294":"418c5753","chunk-f3114b1a":"bc1c5ecd","chunk-5bac093c":"d9089a25","chunk-77d3458c":"67bb2520","chunk-f82ffbdc":"af19181d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0271a4fe":1,"chunk-01cd1471":1,"chunk-2595df72":1,"chunk-4b7bd220":1,"chunk-7caefa32":1,"chunk-96a43c8c":1,"chunk-047dd522":1,"chunk-04800f29":1,"chunk-0dd84c1c":1,"chunk-16c503df":1,"chunk-1f099dec":1,"chunk-20533f34":1,"chunk-2857cb7b":1,"chunk-2bfb1400":1,"chunk-2d5cec40":1,"chunk-2fd67220":1,"chunk-3140e884":1,"chunk-3d2ddda4":1,"chunk-3fd29c42":1,"chunk-4259022d":1,"chunk-43b69a23":1,"chunk-45e957a2":1,"chunk-4dd3fbf5":1,"chunk-4f919cd6":1,"chunk-5b93a306":1,"chunk-5cbc4bea":1,"chunk-625c0003":1,"chunk-6809adbd":1,"chunk-694f629f":1,"chunk-6e227986":1,"chunk-704dd3c0":1,"chunk-72c176ea":1,"chunk-7e408375":1,"chunk-7f9fa58a":1,"chunk-8c26676c":1,"chunk-9cc31c2a":1,"chunk-aa8c7f08":1,"chunk-da7642cc":1,"chunk-de7a6294":1,"chunk-f3114b1a":1,"chunk-5bac093c":1,"chunk-77d3458c":1,"chunk-f82ffbdc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0271a4fe":"5ab2295d","chunk-01cd1471":"b624aeca","chunk-2595df72":"b7f1b11c","chunk-4b7bd220":"57b46265","chunk-7caefa32":"90dc3077","chunk-96a43c8c":"cbcbb787","chunk-047dd522":"25f12a2d","chunk-04800f29":"4cc28082","chunk-0dd84c1c":"2bf02a14","chunk-16c503df":"0821ebaa","chunk-1f099dec":"22246f45","chunk-20533f34":"bc133142","chunk-2857cb7b":"46807a22","chunk-2bfb1400":"55caf9be","chunk-2d5cec40":"a27f7cc1","chunk-2fd67220":"33cbafa3","chunk-3140e884":"820c54ba","chunk-3d2ddda4":"c7d3ff43","chunk-3fd29c42":"8e6c813b","chunk-4259022d":"99d1f05b","chunk-43b69a23":"82bad6bc","chunk-45e957a2":"be2b99aa","chunk-4dd3fbf5":"3a5fcacf","chunk-4f919cd6":"0328cad0","chunk-5b93a306":"ad0213a9","chunk-5cbc4bea":"b77e4b9b","chunk-625c0003":"b9a11862","chunk-6809adbd":"74f1d00b","chunk-694f629f":"34fbcdc5","chunk-6e227986":"ee2c2a76","chunk-704dd3c0":"40168208","chunk-72c176ea":"68ae6a34","chunk-7e408375":"e3241cde","chunk-7f9fa58a":"0e9c0171","chunk-8c26676c":"6ff2452e","chunk-9cc31c2a":"cc5150fc","chunk-aa8c7f08":"7b76a043","chunk-da7642cc":"faed6ee4","chunk-de7a6294":"fa08d650","chunk-f3114b1a":"0e87e2e0","chunk-5bac093c":"491df124","chunk-77d3458c":"d7fd7c02","chunk-f82ffbdc":"1be40f17"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/new-energy/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
